<form [formGroup]="form" class="h-full" (submit)="onSubmit()">
  <div class="flex h-full items-center pl-12 pr-8">
    <div class="w-full max-w-[330px]">
      <div>
        <p class="text-[26px] leading-[39px] text-[#100440]">
          <span class="mr-1 font-bold">Enter</span>
          <span class="font-normal">Verification Code</span>
        </p>
        <p class="mt-3 text-[14px] font-normal leading-[21px] text-[#666666]">
          A 6 digit verification code was sent to
        </p>
        <p class="text-[14px] font-medium text-[#7B49DB]">
          {{ maskedEmail || "your email address" }}
        </p>
      </div>

      <p class="mt-10 text-[16px] text-[#11151F] font-[700] text-[#1f2630]">
        Enter the code below to continue
      </p>

      <div class="mt-4 flex w-full justify-between">
        <input
          #otpInput
          *ngFor="let index of otpIndexes"
          type="text"
          class="h-[60px] w-[45px] rounded-[16px] border bg-white text-center text-[24px] font-[400] leading-none text-[#333333] outline-none transition-[box-shadow,border-color] duration-200 rounded-[16px]"
          [ngClass]="
            errorMessage
              ? 'border-[#EC0A64] focus:border-[#EC0A64] focus:shadow-[0px_0px_12px_0px_#ec0a6440]'
              : 'border-[#4a4a4a] focus:border-[#7b49db] focus:shadow-[0px_0px_12px_0px_#7b49db4d]'
          "
          [value]="otpValues[index]"
          maxlength="1"
          inputmode="numeric"
          pattern="[0-9]*"
          [attr.autocomplete]="index === 0 ? 'one-time-code' : 'off'"
          [attr.aria-label]="'Verification digit ' + (index + 1)"
          (input)="onDigitInput($event, index)"
          (keydown)="onDigitKeydown($event, index)"
          (focus)="onDigitFocus(index)"
          (paste)="onPaste($event, index)"
        />
      </div>

      <div
        *ngIf="errorMessage"
        class="mt-2 text-center text-[14px] font-normal leading-[24px] text-[#EC0A64]"
      >
        {{ errorMessage }}
      </div>

      <div
        class="mt-4 text-right text-[12px] font-medium leading-[18px] text-[#4b2d7c]"
      >
        <button
          type="button"
          class="border-0 bg-transparent text-[14px] font-medium text-[#7B49DB] hover:underline disabled:cursor-not-allowed disabled:text-[#999]"
          (click)="onResend()"
          [disabled]="resending"
        >
          {{ resending ? "Sending..." : "Resend code" }}
        </button>
      </div>

      <button
        #verifyButton
        [disabled]="isDisabled || loading"
        class="mt-8 login-btn flex justify-center items-center block w-[310px] h-[60px] mt-4 outline-none"
      >
        <svg
          *ngIf="loading; else notLoading"
          class="animate-spin"
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask id="path-1-inside-1_914_5279" fill="white">
            <path
              d="M15 1.25168e-06C17.9667 1.122e-06 20.8668 0.879735 23.3336 2.52796C25.8003 4.17618 27.7229 6.51886 28.8582 9.25975C29.9935 12.0006 30.2906 15.0166 29.7118 17.9264C29.133 20.8361 27.7044 23.5088 25.6066 25.6066C23.5088 27.7044 20.8361 29.133 17.9264 29.7118C15.0166 30.2906 12.0006 29.9935 9.25975 28.8582C6.51886 27.7229 4.17618 25.8003 2.52796 23.3336C0.879734 20.8668 -5.61369e-07 17.9667 -6.55671e-07 15L3 15C3 17.3734 3.70379 19.6935 5.02236 21.6668C6.34094 23.6402 8.21509 25.1783 10.4078 26.0866C12.6005 26.9948 15.0133 27.2324 17.3411 26.7694C19.6689 26.3064 21.8071 25.1635 23.4853 23.4853C25.1635 21.8071 26.3064 19.6689 26.7694 17.3411C27.2324 15.0133 26.9948 12.6005 26.0866 10.4078C25.1783 8.21509 23.6402 6.34094 21.6668 5.02236C19.6935 3.70379 17.3734 3 15 3L15 1.25168e-06Z"
            />
          </mask>
          <path
            d="M15 1.25168e-06C17.9667 1.122e-06 20.8668 0.879735 23.3336 2.52796C25.8003 4.17618 27.7229 6.51886 28.8582 9.25975C29.9935 12.0006 30.2906 15.0166 29.7118 17.9264C29.133 20.8361 27.7044 23.5088 25.6066 25.6066C23.5088 27.7044 20.8361 29.133 17.9264 29.7118C15.0166 30.2906 12.0006 29.9935 9.25975 28.8582C6.51886 27.7229 4.17618 25.8003 2.52796 23.3336C0.879734 20.8668 -5.61369e-07 17.9667 -6.55671e-07 15L3 15C3 17.3734 3.70379 19.6935 5.02236 21.6668C6.34094 23.6402 8.21509 25.1783 10.4078 26.0866C12.6005 26.9948 15.0133 27.2324 17.3411 26.7694C19.6689 26.3064 21.8071 25.1635 23.4853 23.4853C25.1635 21.8071 26.3064 19.6689 26.7694 17.3411C27.2324 15.0133 26.9948 12.6005 26.0866 10.4078C25.1783 8.21509 23.6402 6.34094 21.6668 5.02236C19.6935 3.70379 17.3734 3 15 3L15 1.25168e-06Z"
            fill="#7252AE"
            stroke="#7252AE"
            stroke-width="2"
            mask="url(#path-1-inside-1_914_5279)"
          />
        </svg>

        <ng-template #notLoading>Verify</ng-template>
      </button>

      <div class="mt-6 text-center">
        <button
          type="button"
          class="inline-flex items-center gap-1 text-[16px] font-medium text-[#4b2d7c] no-underline hover:underline"
          (click)="onBackToLogin()"
        >
          <span aria-hidden="true"
            ><svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M17 12L7 12"
                stroke="#333333"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M11 16L7 12L11 8"
                stroke="#333333"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              /></svg
          ></span>
          Back to Login
        </button>
      </div>
    </div>
  </div>
</form>
